"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = require("clsx");
const LoadingSpinner = ({ size = 'md', className }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)('animate-spin rounded-full border-b-2 border-current', {
            'h-4 w-4': size === 'sm',
            'h-8 w-8': size === 'md',
            'h-12 w-12': size === 'lg',
        }, className), role: "status", "aria-label": "Loading", children: (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Loading..." }) }));
};
exports.LoadingSpinner = LoadingSpinner;
